import type { FC } from "react";

import { ECategoryReferralsType } from "app/pages/website-analysis/website-structure/pages/ReferralsWrapper";
import { WWOTopReferringWebsitesTable } from "app/pages/website-performance/components/TopReferringWebsites/WWOTopReferringWebsitesTable";
import { proNavigator } from "single-spa/react-app/ProNavigator";

export const WWOTopReferringWebsitesContainerDS: FC = () => {
    const params = proNavigator.getParams();

    const getCtaLink = () => {
        return {
            href: proNavigator.href("digitalsuite_website_referrals_incomingtraffic", {
                ...params,
                selectedTab: ECategoryReferralsType.IncomingTraffic,
            }),
            target: "_self",
        };
    };
    return (
        <WWOTopReferringWebsitesTable
            getCtaLink={getCtaLink}
            unlockHook={{
                component: "WebReferralIncomingTraffic",
                hookModal: "referrals",
            }}
        />
    );
};
